import { Inject, Options, Prop, Vue } from "vue-property-decorator";
import LoadingSpinner from "@/shared/components/loading-spinner/index.vue";
import ModalBox from "@/shared/components/modal-box/index.vue";
import { EventEmitter } from "events";
import ErrorIndicator from "@/shared/components/error-indicator/index.vue";
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import { TrustAPI } from "@/shared/modules/trust-api";
import store from "@/trust-admin-app/store";
import { InvestigatorWorkingPaperView } from "@/shared/modules/typescript-trustapi-client/models";
import FileDragAndDrop from "@/shared/components/file-drag-and-drop/index.vue";
import AlertBox from '@/shared/components/alert-box/index.vue';
import { FilePreviewData } from "@/shared/components/file-preview/file-preview-data";
import FilePreview from "@/shared/components/file-preview/index.vue";

@Options({
  components: {
    ModalBox,
    LoadingSpinner,
    LoadingIndicator,
    ErrorIndicator,
    FileDragAndDrop,
    FilePreview,
    AlertBox
  }
})
export default class AddeditIWPModal extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Prop()
  private iWP!: InvestigatorWorkingPaperView;

  private formData: InvestigatorWorkingPaperView = null as any;
  private submitting = false;
  private fileList: Array<File> = [];
  private showDeleteAlert = false;

  created() : void {
    this.init();
  }

  private init(): void {
    this.formData = JSON.parse(JSON.stringify(this.iWP));
    this.formData.id = this.formData.id ?? 0;
  }

  // private async addNewIWP(): Promise<void> {
  //   try {
  //     this.submitting = true;
  //     if (this.editMode) {
  //       const resp: any = await this.apiService.InvestigatorWorkingPaperApi?.apiV2InvestigatorWorkingPaperSaveInvestigatorWorkingPaperPost(
  //         {
  //           id: this.formData.id,
  //           order: this.formData.order,
  //           investigationId: this.formData.investigationId,
  //           information: this.formData.information,
  //           requiredFinalReport: this.formData.requiredFinalReport,
  //           taggedAsEvidence: this.formData.taggedAsEvidence,
  //           // source: this.formData.source,
  //           // matterDesc: this.formData.matterDesc,
  //           // name: this.formData.name,
  //           // wpRef: this.formData.wpRef
  //         }
  //       );
  //       this.eventCtrl.emit('show-snackbar', 'success', 'IWP updated successfully');
  //     } else {
  //       const fileStr = await this.fileToString(this.fileList[0]);
  //       const resp: any = await this.apiService.InvestigatorWorkingPaperApi?.apiV2InvestigatorWorkingPaperSaveInvestigatorWorkingPaperPost(
  //         {
  //           id: 0,
  //           investigationId: this.formData.investigationId,
  //           information: this.formData.information,
  //           requiredFinalReport: this.formData.requiredFinalReport,
  //           taggedAsEvidence: this.formData.taggedAsEvidence,
  //           fileName: this.fileList[0].name,
  //           fileExtension: '.' + this.fileList[0].name.substring(this.fileList[0].name.indexOf('.') + 1),
  //           fileDataUrl: fileStr
  //         }
  //       );
  //       this.eventCtrl.emit('show-snackbar', 'success', 'IWP added successfully');
  //     }
  //     this.eventCtrl.emit('load-iwp-list');
  //     this.closeModal();
  //   } catch(error) {
  //     if (this.editMode) {
  //       console.log(error);
  //       this.eventCtrl.emit('show-snackbar', 'error', 'Problem updating IWP');
  //     }
  //   } finally {
  //     this.submitting = false;
  //   }
  // }

  private fileListChanged(fileList: Array<File>): void {
    this.fileList = fileList;
  }

  private fileToString(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        return resolve(reader.result as string);
      };

      reader.onabort = () => {
        return reject();
      }

      reader.onerror = () => {
        return reject();
      }
    });
  }

  // private yesDeleteClicked(): void {
  //   this.deleteIWP();
  // }

  // private async deleteIWP(): Promise<void> {
  //   try {
  //     this.submitting = true;
  //     await this.apiService.InvestigatorWorkingPaperApi?.apiV2InvestigatorWorkingPaperDeleteInvestigatorWorkingPaperInvestigatorWorkingPaperIdDelete(
  //       this.formData.id
  //     );
  //     this.eventCtrl.emit('load-iwp-list');
  //     this.closeModal();

  //   } catch {
  //     this.eventCtrl.emit('show-snackbar', 'error', 'Problem deleting file');
  //     this.submitting = false;
  //   }
  // }

  private closeModal(): void {
    this.$emit('closeModal');
  }



  get isFormDirty(): boolean {
    if (this.editMode) {
      return this.formData.information != this.iWP.information ||
        this.formData.requiredFinalReport != this.iWP.requiredFinalReport ||
        this.formData.taggedAsEvidence != this.iWP.taggedAsEvidence;
    } else {
      return this.fileList.length > 0;
    }
  }

  get validForm(): boolean {
    return this.formData.file || this.fileList.length > 0;
  }

  get editMode(): boolean {
    return this.iWP?.id > 0;
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

}

